<template>
  <div>
    <v-alert v-model="showAlert" prominent dense transition="scroll-y-transition" :type="alertMessage.type" :dismissible="false" class="my-2">
      <v-row no-gutters align-center>
        <v-col>
          <div class="d-inline"><span>{{ alertMessage.message }}</span></div>
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      showAlert: false,
      alertMessage: {
        message: "",
        type: "info",
      },
    }
  },

  watch: {
    creditData(newData) {
      if (newData!==undefined) {
        if (Object.keys(newData).length !== 0 && newData.exclusion_kind !== "none") {
          this.showAlert = true;
          this.alertMessage = {
            message: `Excluded from Credit Control until ${ newData.exclude_end_date }`,
            type: 'info'
          };
        } else if(newData.status){
          this.showAlert = true;
          this.alertMessage = {
            message: `This billing account is in the ${newData.status} stage of the credit control funnel.`,
            type: 'error'
          };
        }
      }
    },
  },

  computed: {
    ...mapState("accounts", ["creditData"]),
  }
}
</script>

<style lang="scss" scoped>

</style>